import { InjectionToken } from '../../injection';

export interface IWebConsoleLogHandlerConfiguration {
  enabled: boolean;
}

export const IWebConsoleLogHandlerConfiguration = new InjectionToken('IWebConsoleLogHandlerConfiguration');
